/**
 * Created by zad on 17/9/30.
 */
import React, { Component, Fragment } from 'react';
import { HashRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import i18n from 'react-intl-universal';
import CN from './constants/locales/zh-CN';
import TW from './constants/locales/zh-TW';
import styles from './App.scss';
import { getParameterByName, getCookieByName } from './utils/util';
import {
  setBindPhoneStatus,
  setBindStatus,
  setBindWxStatus,
  setPublishSuccessData,
  setQrCodeModalData,
  setPnAgreeModalData,
  setOccupyHasOther,
  setOccupyNoother,
} from './actions/GlobalAction';
import { getUser } from './actions/UserAction';

import { getState as getUserState } from './reducers/User/UserReducer';
import { getState as getGlobalState } from './reducers/Global/GlobalReducer';

import Routes from './Routes';

import PNAgreeModal from './components/PNAgreeModal/PNAgreeModal';
import PhoneModal from './components/PhoneModal/PhoneModal';
import PublishSuccessModal from './components/PublishSuccessModal/PublishSuccessModal';
import NoAccount from './components/NoAccount/NoAccount';
import QrcodeModal from './components/QrcodeModal/QrcodeModal';
import TimePublishBuyModal from './components/TimePublishBuyModal/TimePublishBuyModal';
import HasOtherAccount from './components/HasBindMordal/HasOtherAccount';
import NoOtherAccount from './components/HasBindMordal/NoOtherAccount';
import message from './components/Message';

const locales = {
  'zh-CN': CN,
  'zh-TW': TW,
};

const fonts = {
  font1: 'song',
  font2: 'black',
};

@connect(
  (state) => {
    const globalState = getGlobalState(state);
    return {
      user: getUserState(state),
      locale: globalState.get('locale'),
      readMode: globalState.get('readMode'),
      fontType: globalState.get('fontType'),
      bindPhoneStatus: globalState.get('bindPhoneStatus'),
      bindStatus: globalState.get('bindStatus'),
      bindWx: globalState.get('bindWx'),
      publishSuccessModalData: globalState.get('publishSuccessModalData'),
      qrCodeModalData: globalState.get('qrCodeModal'),
      pnAgreeModalData: globalState.get('pnAgreeModal'),
      occupyhasother: globalState.get('occupyhasother'),
      occupynother: globalState.get('noOtherAccount'),
    };
  },
  dispatch => ({
    getUser: () => dispatch(getUser()),
    setBindWxStatus: status => dispatch(setBindWxStatus(status)),
    setBindPhoneStatus: status => dispatch(setBindPhoneStatus(status)),
    setBindStatus: (status) => {
      return dispatch(setBindStatus(status));
    },
    setOccupy: ({ status, msg }) => {
      return dispatch(setOccupyHasOther(status, msg));
    },
    setPublishSuccessData: (show, data) => dispatch(setPublishSuccessData(show, data)),
    setQrCodeModalData: (show, data) => dispatch(setQrCodeModalData(show, data)),
    setPnAgreeModalData: (show, data) => dispatch(setPnAgreeModalData(show, data)),
    setNoOther: ({ status, msg, step, data }) =>
      dispatch(setOccupyNoother(status, msg, step, data)),
  }),
)
export default class App extends Component {
  state = {
    initDone: false,
  };

  componentWillMount() {
    this.props.getUser();
  }

  componentDidMount() {
    this.loadLocales();
    this.setBodyClass();
    setTimeout(() => {
      this.getUserState();
    }, 0);
  }

  componentDidUpdate(prevProps) {
    const { readMode, fontType } = this.props;
    if (!(readMode === prevProps.readMode && fontType === prevProps.fontType)) {
      this.setBodyClass();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error, errorInfo) {
    // 上报react error
    if (window.Raven) {
      window.Raven.captureException(error, { extra: errorInfo });
    }
  }

  getUserState() {
    if (getParameterByName('callback')) {
      const bindSnsResult = getCookieByName('bind_sns_result');
      try {
        const res = JSON.parse(decodeURIComponent(decodeURIComponent(bindSnsResult)));
        switch (res.code) {
          case 210:
            return this.props.setOccupy({ status: true, msg: res.message });
          case 211:
            return this.props.setNoOther({
              status: true, msg: res.message, step: 1, data: res.data || '{}',
            });
          case -1:
            return message.success('一键绑定成功');
          case -2:
            return this.props.setNoOther({
              status: true, msg: res.message, step: 2, data: res.data || '{}',
            });
          default:
            return message.error(res.message);
        }
      } catch (e) {
        // handle error
      }
    }
    return false;
  }

  loadLocales() {
    i18n.init({
      currentLocale: this.props.locale,
      locales,
    }).then(() => {
      this.setState({ initDone: true });
    });
  }

  setBodyClass() {
    const { readMode, fontType } = this.props;
    const font = fonts[fontType];
    document.body.className = `reader-${readMode}-mode ${styles[`reader-${font}-font`]}`;
  }

  onWxCancelClick = () => {
    this.props.setBindWxStatus({ status: false });
  }
  onModalCancelClick = () => {
    this.props.setBindStatus({ status: false });
  }
  onPhoneModalConfirmBtnClick = (data = {}) => {
    this.onPhoneModalCancelClick();
  };

  onPhoneModalCancelClick = () => {
    this.props.setBindPhoneStatus(true); // 关闭绑手机的modal时需要重置bindPhoneStatus
  };

  onQrcodeModalCancelClick = () => {
    this.props.setQrCodeModalData(false);
  };
  onHasOtherCancelClick = () => {
    this.props.setOccupy({
      status: false,
    });
  };
  onNoOtherCancelClick = () => {
    this.props.setNoOther({
      status: false,
    });
  }
  onPNAgreeModalConcelBtnClick = () => {
    this.props.setPnAgreeModalData(false, {});
  };

  render() {
    // 是否显示绑定手机的弹层
    const phoneModalVisible = !this.props.bindPhoneStatus;
    const noAccount = !this.props.bindStatus;
    const occupyHasother = this.props.occupyhasother;
    const nowx = !this.props.bindWx;
    const occpyNoother = this.props.occupynother;
    // 是否显示发布文章成功的modal
    const publishSuccessModalData = this.props.publishSuccessModalData.toJS();
    const qrCodeModalData = this.props.qrCodeModalData.toJS();
    const pnAgreeModalData = this.props.pnAgreeModalData.toJS();
    if (this.state.initDone) {
      return (
        <Fragment>
          <HashRouter>
            <Routes/>
          </HashRouter>
          <Fragment>
            {
              phoneModalVisible &&
              <PhoneModal
                visible={phoneModalVisible}
                onModalCancelClick={this.onPhoneModalCancelClick}
                onModalConfirmBtnClick={this.onPhoneModalConfirmBtnClick}
              />
            }
            {
              occupyHasother.status &&
              <HasOtherAccount
                visible={occupyHasother.status}
                onModalCancelClick={this.onHasOtherCancelClick}
              />
            }
            {
              occpyNoother.status &&
              <NoOtherAccount
                visible={occpyNoother.status}
                onModalCancelClick={this.onNoOtherCancelClick}
              />}
            {
              noAccount &&
              <NoAccount
                visible={noAccount}
                onModalCancelClick={this.onModalCancelClick}
                onModalConfirmBtnClick={this.onModalCancelClick}
              />
            }
            {
              publishSuccessModalData.show &&
              <PublishSuccessModal
                data={publishSuccessModalData.data}
              />
            }
            {
              qrCodeModalData.show &&
              <QrcodeModal
                visible={qrCodeModalData.show}
                link={qrCodeModalData.data.link}
                onModalCancel={this.onQrcodeModalCancelClick}
              />
            }
            {
              // 付费协议modal
              <PNAgreeModal
                visible={pnAgreeModalData.show}
                // onModalConfirmBtnClick={this.onPNAgreeModalConfirmBtnClick}
                onModalCancelBtnClick={this.onPNAgreeModalConcelBtnClick}
              />
            }
            <TimePublishBuyModal/>
          </Fragment>
        </Fragment>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App.js